import React from "react";
import Button from 'devextreme-react/button';

function negativeToHexColor(negativeColor) {
  // Convierte el color negativo a un valor hexadecimal positivo

  const hex = (negativeColor >>> 0).toString(16).padStart(6, '0');

  // Extrae los valores RGB
  const red = hex.slice(2, 4);
  const green = hex.slice(4, 6);
  const blue = hex.slice(6, 8);

  // Devuelve el color en formato hexadecimal #RRGGBB
  return `#${red}${green}${blue}`;
}

function LVCuadriculaBoton({ Alto, Ancho, TextoLinea1, TextoLinea2, TextoLinea3, Color, visible, onClick, Disabled=false }) {

  const colorHex = negativeToHexColor(Color);

  return (
    <button
      onClick={onClick}
      disabled={Disabled}
      style={{
        backgroundColor: colorHex,
        borderRadius: '10px',
        margin: '5px',
        border: 'none',
        padding: '1px',
        cursor: visible ? 'pointer' : 'default',
        color: visible ? '#fff' : 'inherit',
        transition: visible ? 'background-color 0.3s ease' : 'none',
        boxShadow: visible ? '0px 4px 6px rgba(0, 0, 0, 0.5)' : 'none',
        width: `${Ancho}px`,
        height: `${Alto}px`,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          whiteSpace: 'pre-line',
          fontSize: '12px',
          textAlign: 'center',
          lineHeight: '1.2',
          fontWeight: 'bold',
        }}>
        <span>{TextoLinea1}</span>
        <span>{TextoLinea2}</span>
        <span>{TextoLinea3}</span>
      </div>
    </button>
  );
}

export default LVCuadriculaBoton;